import { z } from 'zod';

import type { StoreListingModel } from '../models';
import { baseStoreListingModelSchema } from '../models';

/** @see AppleRetail.Web.Features.Stores.StoreManagementODataController.StoreListingModel */
export interface StoreOdataListing
	extends Omit<
		StoreListingModel,
		'warehouseLocationId' | 'timeZone' | 'countryCode' | 'utcOffsetMinutes'
	> {
	countryCode: string;
}

export interface StoreFilters
	extends Partial<
		Omit<
			StoreOdataListing,
			| 'id'
			| 'streetAddress3'
			| 'customerGroupId'
			| 'activeDate'
			| 'inactiveDate'
			| 'logoImageUrl'
			| 'timeZone'
			| 'costCenter'
			| 'goLiveDate'
			| 'expeditedShippingFee'
			| 'recipientName'
			| 'attentionTo'
			| 'status'
		>
	> {
	status?: 'Active' | 'Inactive';
}

/** @see AppleRetail.Web.Features.Stores.StoreManagementODataController.StoreListingModel */
export const baseStoreOdataListingSchema = baseStoreListingModelSchema
	.omit({
		warehouseLocationId: true,
		timeZone: true,
		utcOffsetMinutes: true,
	})
	.extend({
		countryCode: z.string(),
	});

export const storeOdataListingSchema = baseStoreOdataListingSchema as z.ZodType<StoreOdataListing>;

export const storeFiltersSchema = baseStoreOdataListingSchema
	.partial()
	.omit({
		id: true,
		streetAddress3: true,
		customerGroupId: true,
		activeDate: true,
		inactiveDate: true,
		logoImageUrl: true,
		costCenter: true,
		goLiveDate: true,
		expeditedShippingFee: true,
		recipientName: true,
		attentionTo: true,
		status: true,
	})
	.extend({
		status: z.enum(['Active', 'Inactive']).optional(),
	}) satisfies z.ZodType<StoreFilters>;
